import { distinctUntilChanged, merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { AD_BREAKBEGIN, AD_BREAKEND } from '@tv2-player/unifiedplayer/src/core/events';
import { UnifiedPlayer } from '@tv2-player/unifiedplayer/src/types';
import { OverlayManager } from '../overlays';

export default function larOverlayHandler(overlayManager: OverlayManager, player: UnifiedPlayer) {
  const larOverlay = OverlayManager.createOverlayElement(
    'larOverlay',
    'bg-midnight font-tv2 opacity-100 z-[2] flex justify-center items-center text-white flex-col absolute bottom-auto pb-[1vw] left-0 right-0 top-0 transition-opacity duration-200 enabled'
  );
  larOverlay.innerHTML = `
    <h1 class="header">You are experiencing a LAR moment!</h1>
  `;

  const adBreakBegin$ = player.observe(AD_BREAKBEGIN).pipe(map(e => e.isLar));
  const adBreakEnd$ = player.observe(AD_BREAKEND).pipe(map(() => false));

  return merge(adBreakBegin$, adBreakEnd$).pipe(
    distinctUntilChanged(),
    map(showOverlay => {
      if (showOverlay) {
        overlayManager.showOverlay(() => larOverlay);
      } else {
        overlayManager.hideOverlay();
      }
      return showOverlay;
    })
  );
}
